import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-92e89aea")

_pushScopeId("data-v-92e89aea")
const _hoisted_1 = { class: "ctrl-buttons" }
const _hoisted_2 = { class: "content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_base_card = _resolveComponent("base-card")

  return (_openBlock(), _createBlock(_component_base_card, null, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("dig-ui-show-button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goTo(`/simulations/${$props.simulation?.id}`))),
          title: $setup.t('Tooltips.showSimulation'),
          class: "icon-button"
        }, null, 8, ["title"]),
        _createVNode("dig-ui-add-button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.goTo(`/new-simulation/${$props.simulation?.id}`))),
          title: $setup.t('Tooltips.duplicateSimulation'),
          class: "icon-button"
        }, null, 8, ["title"]),
        _createVNode("dig-ui-delete-button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleDelete())),
          title: $setup.t('Tooltips.deleteSimulation'),
          class: "icon-button"
        }, null, 8, ["title"])
      ]),
      _createVNode("div", _hoisted_2, [
        _createVNode("span", {
          class: "go-to",
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.goTo(`/simulations/${$props.simulation?.id}`)))
        }, _toDisplayString($setup.toHumanDate($props.simulation?.date)) + " - " + _toDisplayString($props.simulation?.firstname) + " " + _toDisplayString($props.simulation?.lastname) + " - " + _toDisplayString($setup.t(`Simulation.WorksTypes.${$props.simulation?.name}`)), 1)
      ])
    ]),
    _: 1
  }))
})